import { servicePath } from "constants/defaultValues";
import Cookies from "js-cookie";
import { formatListMessages, parseJson } from "./HtmlHelper";
import { setCurrentUser } from "./Utils";

const buildJsonOptions = (method, params) => {
  return {
    method: method, // 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "include", //'same-origin', // include, *same-origin, omit
    crossDomain: true,
    headers:
      params instanceof FormData
        ? {
            //'Content-Type': 'multipart/form-data',
            "X-CSRF-TOKEN": Cookies.get("csrf_access_token"),
          }
        : {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-TOKEN": Cookies.get("csrf_access_token"),
          },
    // redirect: 'follow', // manual, *follow, error
    // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body:
      params instanceof FormData
        ? params
        : params
        ? JSON.stringify(params)
        : null, // body data type must match "Content-Type" header
  };
};

const mapUrl = (endpoint) => {
  if (endpoint.startsWith("http")) return endpoint;
  const url = servicePath + (servicePath.endsWith("/") ? "" : "/") + endpoint;
  return url;
};

const getParamStr = (params) => {
  if (!params) return "";
  const ret = [];
  for (var p in params) {
    ret.push(`${p}=${params[p]}`);
  }
  return ret.join("&");
};

// const fetchx = async (
//   method,
//   endpoint,
//   params = null,
//   skipRedirectLogin = false
// ) => {
//   const options = buildJsonOptions(method, params);
//   try {
//     let fullUrl = mapUrl(endpoint);
//     if (method == "GET" && params)
//       fullUrl += (fullUrl.includes("?") ? "&" : "?") + getParamStr(params);

//     const response = await fetch(fullUrl, options);
//     if (response.ok) {
//       let data = {};
//       try {
//         data = await response.json(); // this would raise error i.e. Delete method
//       } catch {}
//       console.log(data, endpoint);
//       return { data: data, ok: response.ok, code: response.status };
//     }
//     const msg = await checkResponseAsync(
//       response,
//       () => {
//         return fetchx(endpoint, options);
//       },
//       skipRedirectLogin
//     );
//     return {
//       data: msg == "" ? response.statusText : msg,
//       ok: false,
//       code: response.status,
//     };
//   } catch (ex) {
//     console.log(ex);
//     return errorCatcher(ex);
//   }
// };

const fetchx = async (
  method,
  endpoint,
  params = null,
  skipRedirectLogin = false
) => {
  const options = buildJsonOptions(method, params);
  try {
    let fullUrl = mapUrl(endpoint);
    if (method == "GET" && params)
      fullUrl += (fullUrl.includes("?") ? "&" : "?") + getParamStr(params);
    const response = await fetch(fullUrl, options);

    if (response.ok) {
      let data = {};
      try {
        data = await response?.json(); // this would raise error i.e. Delete method
      } catch {}
      return { data: data, ok: response?.ok, code: response?.status };
    }
    const msg = await checkResponseAsync(
      response,
      () => {
        //console.log("Repeating calling " + endpoint)
        return fetchx(method, endpoint, params, skipRedirectLogin);
      },
      skipRedirectLogin
    );
    if (msg?.ok) {
      return {
        data: msg?.data,
        ok: msg?.ok,
        code: msg?.code,
      };
    }

    let message = null;

    // check if response has a body

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
      try {
        message = await response.json();
      } catch (e) {
        message = null;
      }
    }

    if (message) {
      return {
        data: message?.message ?? msg?.data ?? message ?? msg,
        ok: false,
        code: response?.status ?? msg?.code,
      };
    } else {
      return {
        data: response?.statusText ?? msg?.statusText,
        ok: false,
        code: response?.status ?? msg?.status,
      };
    }
  } catch (ex) {
    console.log(ex);
    return errorCatcher(ex);
  }
};

const fetchx2 = async (method, endpoint, params = null) => {
  const options = buildJsonOptions(method, params);
  try {
    let fullUrl = mapUrl(endpoint);
    if (method == "GET" && params)
      fullUrl += (fullUrl.includes("?") ? "&" : "?") + getParamStr(params);

    const response = await fetch(fullUrl, options);
    if (response.ok) {
      let data = {};
      try {
        data = await response.json(); // this would raise error i.e. Delete method
      } catch {}
      return { data: data, ok: response.ok, code: response.status };
    }

    return {
      data: await response.json(),
      ok: false,
      code: response.status,
    };
  } catch (ex) {
    console.log(ex);
    return errorCatcher(ex);
  }
};

const errorCatcher = (ex) => {
  console.log(ex);
  let errMsg = ex.message;
  if (errMsg == "Failed to fetch")
    errMsg = `Could not connect to API server. Please try again later.`;
  return {
    data: errMsg,
    ok: false,
    code: 500,
  };
};

const getBlob = async (endpoint) => {
  const options = buildJsonOptions("GET", null);
  try {
    const response = await fetch(mapUrl(endpoint), options);
    if (response.ok) {
      const data = await response.blob();
      return { data: data, ok: response.ok, code: response.status };
    }
    const msg = await checkResponseAsync(response, () => {
      return getBlob(endpoint);
    });
    return { data: msg, ok: false, code: response.status };
  } catch (ex) {
    return errorCatcher(ex);
  }
};

const postBlob = async (endpoint, params) => {
  const options = buildJsonOptions("POST", params);
  try {
    const response = await fetch(mapUrl(endpoint), options);
    if (response.ok) {
      const data = await response.blob();
      return { data: data, ok: response.ok, code: response.status };
    }
    const msg = await checkResponseAsync(response, () => {
      return postBlob(endpoint, params);
    });
    return { data: msg, ok: false, code: response.status };
  } catch (ex) {
    return errorCatcher(ex);
  }
};

const get = async (endpoint, params = null) => {
  return fetchx("GET", endpoint, params);
};

const tryGet = async (endpoint, params = null) => {
  return await fetchx("GET", endpoint, params, true);
};

const post = async (endpoint, params) => {
  return fetchx("POST", endpoint, params);
};

const put = async (endpoint, params) => {
  return fetchx("PUT", endpoint, params);
};

const postOrPut = async (endpoint, editingId, params) => {
  if (editingId) {
    const url =
      endpoint + (endpoint.endsWith("/") ? editingId : "/" + editingId);
    return put(url, params);
  }
  return post(endpoint, params);
};

const postLogin = async (endpoint, params) => {
  return await fetchx2("POST", endpoint, params, true);
};

const deletex = async (endpoint) => {
  return fetchx("DELETE", endpoint);
};

// const checkResponseAsync = async (
//   response,
//   onAuthRefreshed,
//   skipRedirectLogin = false
// ) => {
//   let msg = await response.text();

//   if (
//     msg.includes("Signature has expired") ||
//     msg.includes("Session has expired")
//   ) {
//     const refreshRes = await post("v2/auth/refresh", {});
//     if (refreshRes.ok) {
//       console.log("Token refreshed.");
//       if (onAuthRefreshed) {
//         onAuthRefreshed();
//         return "";
//       }
//     }
//   }

//   if (response.status === 401 && skipRedirectLogin == false) {
//     localStorage.clear();
//     window.location.href = "/account/login";
//   }

//   try {
//     const err = parseJson(msg);
//     if (err) msg = stringifyError(err);
//   } finally {
//     return msg;
//   }
// };

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
  refreshSubscribers.push(callback);
}

function onRefreshed() {
  refreshSubscribers.forEach((callback) => callback("refresh-success"));
  refreshSubscribers = [];
}

function onRefreshFailed() {
  refreshSubscribers.forEach((callback) => callback("refresh-failed"));
  refreshSubscribers = [];
}

function safeRedirectToLogin() {
  const alreadyRedirected = localStorage.getItem("redirectedToLogin");
  const isLoginPage = window.location.pathname.includes("/login");
  if (!alreadyRedirected && !isLoginPage) {
    localStorage.setItem("redirectedToLogin", true);
    localStorage.setItem("SavedUrl", JSON.stringify(window.location.pathname));
    window.location.href = "/account/login";
  }
}

const checkResponseAsync = async (
  response,
  onAuthRefreshed,
  skipRedirectLogin = false
) => {
  if (response.status === 429) {
    const customMsg = await response?.text();
    return (
      customMsg?.replace(/^"|"$/g, "") ||
      "Access limit reached. Hold on until next 15 seconds."
    );
  }

  if (response.status === 401 && !skipRedirectLogin) {
    const waitForRefresh = new Promise((resolve) => {
      subscribeTokenRefresh(async (status) => {
        if (status === "refresh-failed") {
          setCurrentUser(null);
          safeRedirectToLogin();
          resolve("Unauthorized");
        } else if (status === "refresh-success") {
          const result = onAuthRefreshed ? await onAuthRefreshed() : null;

          resolve({
            data: result?.data,
            code: result?.code,
            ok: result?.ok,
          });
        }
      });
    });

    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        if (isRefreshing) {
          isRefreshing = false;
          onRefreshFailed();
          setCurrentUser(null);
          safeRedirectToLogin();
          resolve("Unauthorized");
        }
      }, 5000); // 10 seconds
    });

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        const refreshRes = await post("V2/auth/refresh", {});
        if (refreshRes.ok) {
          setCurrentUser(refreshRes.data);
          isRefreshing = false;
          onRefreshed();
        } else {
          isRefreshing = false;
          onRefreshFailed();
          setCurrentUser(null);
          safeRedirectToLogin();
        }
      } catch (err) {
        isRefreshing = false;
        onRefreshFailed();
        setCurrentUser(null);
        safeRedirectToLogin();
      }
    }

    return Promise.race([waitForRefresh, timeout]);
  }
  return response;
};

const stringifyError = (err) => {
  let msg = "";
  if (err?.errors) {
    //&& errJson.type?.includes("https://tools.ietf.org/html/")) {
    msg = formatListMessages(`${err.status}: ${err.title}`, err.errors);
  } else if (err?.message) msg = err.message;
  else msg = JSON.stringify(err);
  return msg;
};

const apix = {
  get,
  post,
  put,
  postOrPut,
  postLogin,
  deletex,
  getBlob,
  postBlob,
  tryGet,
  mapUrl,
};
export default apix;
